import { NavLink } from 'react-router-dom';
import {
  Activity,
  Droplets,
  MapPin,
  Radio,
  CreditCard,
  Tablet,
  Package,
  BookOpen,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { InventoryType } from '../../modules/inventory/types';
import { buttonVariants } from 'components/ui/button';
import { cn } from 'lib/utils';

export const inventoryCategories = [
  { type: InventoryType.MACHINE_ACTIVITY, label: 'machineActivity', icon: Activity, description: 'Maskinaktivitet, udstyr og SIM-kort.' },
  {
    type: InventoryType.IPAD,
    label: 'ipad',
    icon: Tablet,
    description: 'Serienumre, SIM-kort og afdelinger.',
  },
  {
    type: InventoryType.GPS,
    label: 'gps',
    icon: MapPin,
    description: 'GPS-enheder og deres tilknytning.',
  },
  {
    type: InventoryType.FOOBOT,
    label: 'foobot',
    icon: Activity,
    description: 'Foobot-sensorer og lagerstatus.',
  },
  {
    type: InventoryType.ESP_AQ,
    label: 'dust',
    icon: Radio,
    description: 'Sensorstatus, SIM-kort og tags.',
  },
  {
    type: InventoryType.PUMP,
    label: 'pumps',
    icon: Droplets,
    description: 'Pumper, priser og afdelinger.',
  },
  {
    type: InventoryType.SIM_CARDS,
    label: 'simcards',
    icon: CreditCard,
    description: 'ICCID, tags og tilsluttet udstyr.',
  },
];

export default function InventoryNav() {
  const { t } = useTranslation();
  return (
    <nav aria-label={t('header.inventory')} className="flex flex-wrap gap-1 border-b pb-3">
      <NavLink
        exact
        to="/inventory"
        className={cn(
          buttonVariants({ variant: 'ghost', size: 'sm' }),
          'text-muted-foreground hover:!text-foreground'
        )}
        activeClassName="!bg-primary !text-primary-foreground"
        aria-label={t('Lageroversigt')}
      >
        <Package aria-hidden="true" />
        <span>{t('Oversigt')}</span>
      </NavLink>
      <NavLink
        to="/inventory/machine-catalogue"
        className={cn(
          buttonVariants({ variant: 'ghost', size: 'sm' }),
          'text-muted-foreground hover:!text-foreground'
        )}
        activeClassName="!bg-primary !text-primary-foreground"
      >
        <BookOpen aria-hidden="true" />
        <span>{t('Maskinkatalog')}</span>
      </NavLink>
      <NavLink
        to="/inventory/sensors"
        className={cn(buttonVariants({ variant: 'ghost', size: 'sm' }), 'text-muted-foreground')}
        activeClassName="!bg-primary !text-primary-foreground"
      >
        <Radio aria-hidden="true" />
        <span>Alle sensorer og koblinger</span>
      </NavLink>
      {inventoryCategories.map(({ type, label, icon: Icon }) => (
        <NavLink
          key={type}
          to={`/inventory/${type}`}
          className={cn(
            buttonVariants({ variant: 'ghost', size: 'sm' }),
            'text-muted-foreground hover:!text-foreground'
          )}
          activeClassName="!bg-primary !text-primary-foreground"
        >
          <Icon aria-hidden="true" />
          <span>{t(label === 'machineActivity' ? 'Maskinaktivitet' : label === 'simcards' ? 'SIM-kort' : `sidenavInventory.${label}`)}</span>
        </NavLink>
      ))}
    </nav>
  );
}
